'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00249 from "./presto.-Login-Page-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$8() {
  this.b6z = null;
  this.b6r = null;
  this.b6s = false;
  this.b6A = null;
  this.b6B = false;
  this.b6E = null;
  this.b6x = null;
  this.b6y = false;
  this.b6t = null;
  this.b6u = false;
  this.b6v = null;
  this.b6w = false;
  this.b6C = false;
  this.b6D = false;
  this.b6z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6E = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$8 as $c_Lpresto_LoginPageView$$anon$8 };
$p = $c_Lpresto_LoginPageView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$8;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$8() {
}
export { $h_Lpresto_LoginPageView$$anon$8 as $h_Lpresto_LoginPageView$$anon$8 };
$h_Lpresto_LoginPageView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b6z;
});
$p.M = (function() {
  if ((!this.b6s)) {
    this.b6r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b6s = true;
  }
  return this.b6r;
});
$p.O = (function() {
  if ((!this.b6B)) {
    this.b6A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b6B = true;
  }
  return this.b6A;
});
$p.E = (function() {
  return this.b6E;
});
$p.t = (function() {
  if ((!this.b6y)) {
    this.b6x = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b6y = true;
  }
  return this.b6x;
});
$p.N = (function() {
  if ((!this.b6u)) {
    this.b6t = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b6u = true;
  }
  return this.b6t;
});
$p.Q = (function() {
  if ((!this.b6w)) {
    this.b6v = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00249.$c_Lpresto_LoginPageView$$anon$9();
    this.b6w = true;
  }
  return this.b6v;
});
$p.v = (function() {
  if ((!this.b6D)) {
    this.b6C = false;
    this.b6D = true;
  }
  return this.b6C;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee61) => ((p) => \u03b4scrutinee61.Gp(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$8, "presto.LoginPageView$$anon$8", ({
  Mv: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$8 as $d_Lpresto_LoginPageView$$anon$8 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$8.js.map
